
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PianoRemovalsLondon from "../pages/piano-removals-london/page";
import PianoMoversLondon from "../pages/piano-movers-london/page";
import PianoRemovalCostLondon from "../pages/piano-removal-cost-london/page";
import GrandPianoRemovalLondon from "../pages/grand-piano-removal-london/page";
import UprightPianoRemovalLondon from "../pages/upright-piano-removal-london/page";
import PianoStorageLondon from "../pages/piano-storage-london/page";
import ContactUs from "../pages/contact-us/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/piano-removals-london",
    element: <PianoRemovalsLondon />,
  },
  {
    path: "/piano-movers-london",
    element: <PianoMoversLondon />,
  },
  {
    path: "/piano-removal-cost-london",
    element: <PianoRemovalCostLondon />,
  },
  {
    path: "/grand-piano-removal-london",
    element: <GrandPianoRemovalLondon />,
  },
  {
    path: "/upright-piano-removal-london",
    element: <UprightPianoRemovalLondon />,
  },
  {
    path: "/piano-storage-london",
    element: <PianoStorageLondon />,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
